import React from "react";
import "./StatusPill.css";

const TONE_ICONS = {
  success: "fa fa-check",
  danger: "fa fa-times-circle",
  warning: "fa fa-clock",
  info: "fa fa-circle",
  accent: null,
  neutral: "fa fa-pencil-alt",
};

const StatusPill = ({ tone = "neutral", icon, children, className = "" }) => {
  if (children === null || children === undefined || children === "") return null;
  const resolvedIcon = icon === undefined ? TONE_ICONS[tone] : icon;
  return (
    <span className={`status-pill status-pill--${tone} ${className}`.trim()}>
      {resolvedIcon && <i className={resolvedIcon} aria-hidden="true" />}
      <span>{children}</span>
    </span>
  );
};

export default StatusPill;
